export enum FileRenderer {
  threedViewer = '3d-viewer',
  image = 'image',
  video = 'video',
  sdsplink = 'sdsplink',
  pdf = 'pdf',
}
